import { render, staticRenderFns } from "./PMStructureCreateModal.vue?vue&type=template&id=45fa582c&"
import script from "./PMStructureCreateModal.vue?vue&type=script&lang=ts&"
export * from "./PMStructureCreateModal.vue?vue&type=script&lang=ts&"
import style0 from "./PMStructureCreateModal.vue?vue&type=style&index=0&id=45fa582c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports